(() => {
  let t = (e) => {
    let a,
      r = (a = document.currentScript
        ? document.currentScript.parentElement
        : e).querySelectorAll(".media-banner__collections-item");
    a.querySelector(".media-banner__collections");
    r.forEach((t) => {
      t.addEventListener("mouseover", (e) => {
        r.forEach((e) => {
          e.classList.add("media-banner__collections-item--opacity");
        }),
          t.classList.remove("media-banner__collections-item--opacity"),
          t.addEventListener("mouseout", () => {
            r.forEach((e) => {
              e.classList.remove("media-banner__collections-item--opacity");
            });
          });
      });
    });
    e = a.querySelector(".banner__marquee");
    if (e) {
      let r =
        575 < document.documentElement.clientWidth
          ? 7e3 * e.getAttribute("data-ticker-speed")
          : 3e3 * e.getAttribute("data-ticker-speed");
      if (!e.querySelector(".js-marquee-wrapper")) {
        e.classList.add("marquee");
        let t = $(e);
        t.marquee({
          delayBeforeStart: 0,
          direction: "left",
          allowCss3Support: !0,
          startVisible: !0,
          duration: r,
          gap: 0,
        }),
          new ResizeObserver((e) => {
            var [,] = e;
            t.marquee("destroy"),
              t.marquee({
                delayBeforeStart: 0,
                direction: "left",
                allowCss3Support: !0,
                startVisible: !0,
                duration: r,
                gap: 0,
              });
          }).observe(a);
      }
    }
  };
  t(),
    document.addEventListener("shopify:section:load", function (e) {
      t(e.target);
    });
})();
